import React, { useEffect, useState } from 'react';
import styles from './InputQuestion.module.css';

function InputQuestion({ data, answer, handleAnswerChange, isMarked }) {
  // Track if the field should be hidden/disabled based on the initial value of `answer`
  const [shouldHide, setShouldHide] = useState(false);

  useEffect(() => {
    if (data.id === 9) {
      // Set `shouldHide` only once based on the initial value of `answer`
      setShouldHide(answer !== null && answer !== undefined && answer !== '');
    }
  }, [data.id]); // Run only once when the component mounts

  const handleInputChange = (event) => {
    handleAnswerChange(data.id, event.target.value);
  };

  return (
    <div className={isMarked ? styles.marked : ''}>
      <label className={styles.label}>{data.question}</label>
      <div className={`${styles.wrapper} ${shouldHide ? styles.hidden : ''}`}>
        <input
          className={styles.input}
          type="text"
          value={answer || ""}
          onChange={handleInputChange}
          disabled={shouldHide}
        />
      </div>
      {/* Show the answer as text when input is hidden */}
      {shouldHide && (
        <div className={styles.staticAnswer}>
          {answer}
        </div>
      )}
    </div>
  );
}

export default InputQuestion;
